module.exports = __webpack_public_path__ + "static/img/13.64e9888.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/13.png
// module id = LigA
// module chunks = 0